import { useEffect, useState, useMemo } from "react"
import BaseTable from "./BaseTable"
import exerciseResultService from "../../services/exerciseResultService"
import { useLocation } from "react-router-dom"
import { format} from "date-fns"
import studentImage from "../../assets/images/student.png"

export default function HistoryExerciseResultTable () {

  const location = useLocation()
  const query = new URLSearchParams(location.search);
  const exercise_id = query.get('exercise');
  const [histories, setHisTories] = useState([])
  useEffect(() => {
    if (exercise_id)
    fetchMyExerciseResult(exercise_id)
  }, [exercise_id])
  const fetchMyExerciseResult = async () => {
    const response = await exerciseResultService.getMyResultByExerciseId(exercise_id)
    setHisTories(response.data)
  }
  const data = useMemo(
    () => histories,
    [histories]
  )
  const columns = useMemo(
    () => [
      { header: "Điểm số", accessorKey: "score", cell: ({row}) => (
        <p>
          {Math.ceil(row.original.score)}
        </p>
      ) },
      { header: "Số câu đúng", accessorKey: "correct" },
      { header: "Ngày thực hiện", accessorKey: "taken_at", cell: ({row}) =>  (
        <span>{format(row.original.taken_at,"HH:mm - dd/MM/yyyy")}</span>
   ) },

    ],
    []
  );

  return (
    <>
    <BaseTable data={data} columns={columns} />
    {histories.length===0 ?
    <div className="flex justify-center flex-col items-center">
      <img src={studentImage} alt="student"/>
      <p className="text-gray-600 font-bold text-xl">Nhấn bắt đầu để làm bài!</p>
      </div>
      :
      null
    }
    </>
  )
}
